// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"dZ-z","subtitle":"eZ-z","wrapper":"fZ-z","leftArrow":"gZ-z","rightArrow":"hZ-z"};